<template>
  <IconInfoCircle
    v-if="!state"
    class="info"
    role="button"
    tabindex="0"
    @click="onClick"
    @keydown.enter="onClick"
    @keydown.space="(event: Event) => onClick(event, true)"
  />
  <IconTimeLine
    v-else
    class="info"
    role="button"
    tabindex="0"
    @click="onClick"
    @keydown.enter="onClick"
    @keydown.space="(event: Event) => onClick(event, true)"
  />
</template>

<script lang="ts" setup>
import IconInfoCircle from '@/design-system/assets/icons/IconInfoCircle.vue'
import IconTimeLine from '@/design-system/assets/icons/IconTimeLine.vue'

const emit = defineEmits(['click'])
defineProps<{
  state: boolean
}>()

function onClick(event?: Event, preventDefault?: boolean) {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  emit('click')
}
</script>

<style lang="scss" scoped>
.info {
  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: auto;
  }
  &:hover {
    cursor: pointer;
  }
}
</style>
